import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import gearIcon from "./img/gear.png";
import { useConfig } from "./ConfigContext";

import { useEffect } from "react";
export default function ObjektMenu({
   fieldconfiguration,
   sendData,
   estatekacheln,
   basicdata,
   setBasicData,
   changeData,
   userlist,
   user,
   loading,
   setEskStatus,
   eskstatus,
   userObjects,
   disableProjektstufen,
}) {
   const config = useConfig();

   const [show, setShow] = useState(false);
   const [oldData, setOldData] = useState();
   const [oldEskData, setOldEskData] = useState();

   function abbrechen() {
      console.log(oldEskData);

      setEskStatus(oldEskData);
      setBasicData(oldData);
      setShow(false);
   }

   return (
      <>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => {
                  setOldData(basicdata);
                  console.log(eskstatus);

                  setOldEskData(eskstatus);
                  setShow(true);
               }}
               className="custom-button"
               style={{ position: "absolute", width: "56px", right: 0, zIndex: 0 }}
               title="Objekteinstellungen öffnen"
            >
               <img src={gearIcon} />{" "}
            </button>
         </div>
         <Modal show={show} size="xl" dialogClassName="xxl-modal" className="" onHide={abbrechen}>
            <Modal.Body>
               <Form>
                  <Row>
                     {config.estate.einkaeufer && (
                        <Col>
                           <Form.Group controlId={"id_ek"} className="mb-3">
                              <Form.Label>Einkauf</Form.Label>
                              <Form.Select
                                 className={basicdata[config.estate.einkaeufer] ? "" : "empty-field"}
                                 name={config.estate.einkaeufer}
                                 onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                 value={basicdata[config.estate.einkaeufer] ? basicdata[config.estate.einkaeufer] : ""}
                              >
                                 <option value=""></option>
                                 <option value={user.id}>
                                    {user.Vorname} {user.Nachname}
                                 </option>
                                 {userlist &&
                                    userlist.map((user, index) => (
                                       <option
                                          key={"selectuser_" + user.Name + config.estate.einkaeufer}
                                          value={user.id}
                                       >
                                          {user.Nachname + " " + user.Vorname}
                                       </option>
                                    ))}
                              </Form.Select>
                           </Form.Group>
                        </Col>
                     )}
                     {config.estate.backofficekraft && (
                        <Col>
                           <Form.Group controlId={"id_ek"} className="mb-3">
                              <Form.Label>Backoffice</Form.Label>
                              <Form.Select
                                 className={basicdata[config.estate.backofficekraft] ? "" : "empty-field"}
                                 name={config.estate.backofficekraft}
                                 onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                 value={
                                    basicdata[config.estate.backofficekraft]
                                       ? basicdata[config.estate.backofficekraft]
                                       : ""
                                 }
                              >
                                 <option value=""></option>
                                 <option value={user.id}>
                                    {user.Vorname} {user.Nachname}
                                 </option>
                                 {userlist &&
                                    userlist.map((user, index) => (
                                       <option
                                          key={"selectuser_" + user.Name + config.estate.backofficekraft}
                                          value={user.id}
                                       >
                                          {user.Nachname + " " + user.Vorname}
                                       </option>
                                    ))}
                              </Form.Select>
                           </Form.Group>
                        </Col>
                     )}
                  </Row>
                  <Row>
                     <Col>
                        <Form.Group controlId={"id_benutzer"} className="mb-3">
                           <Form.Label>Projektmanagement</Form.Label>
                           <Form.Select
                              className={basicdata["benutzer"] ? "" : "empty-field"}
                              name={"benutzer"}
                              onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                              value={basicdata["benutzer"] ? basicdata["benutzer"] : ""}
                           >
                              <option value=""></option>
                              <option value={user.id}>
                                 {user.Vorname} {user.Nachname}
                              </option>
                              {userlist &&
                                 userlist.map((user, index) => (
                                    <option key={"selectuser_" + user.Name + "benutzer"} value={user.id}>
                                       {user.Nachname + " " + user.Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form.Group>
                     </Col>
                     {config.estate.abwickler && (
                        <Col>
                           <Form.Group controlId={"id_benutzer"} className="mb-3">
                              <Form.Label>Abwicklung</Form.Label>
                              <Form.Select
                                 className={basicdata[config.estate.abwickler] ? "" : "empty-field"}
                                 name={config.estate.abwickler}
                                 onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                 value={basicdata[config.estate.abwickler] ?? ""}
                              >
                                 <option value=""></option>
                                 <option value={user.id}>
                                    {user.Vorname} {user.Nachname}
                                 </option>
                                 {userlist &&
                                    userlist.map((user, index) => (
                                       <option key={"selectuser_" + user.Name + "benutzer"} value={user.id}>
                                          {user.Nachname + " " + user.Vorname}
                                       </option>
                                    ))}
                              </Form.Select>
                           </Form.Group>
                        </Col>
                     )}
                  </Row>
                  <hr className="mb-1" />
                  <hr className="mb-3" />
                  <Row>
                     <Form.Group as={Col} controlId={"id_status2"} className="mb-3">
                        <Form.Label>Verkaufsstatus</Form.Label>
                        <Form.Select
                           className={basicdata[config.estate.verkaufsStatus] ? "" : "empty-field"}
                           name={[config.estate.verkaufsStatus]}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={
                              basicdata[config.estate.verkaufsStatus] ? basicdata[config.estate.verkaufsStatus] : ""
                           }
                        >
                           <option value=""></option>

                           {fieldconfiguration &&
                              fieldconfiguration.estate &&
                              Object.keys(fieldconfiguration.estate[config.estate.verkaufsStatus].permittedvalues).map(
                                 (status2item, index) => (
                                    <option key={"selectuser_" + status2item} value={status2item}>
                                       {
                                          fieldconfiguration.estate[config.estate.verkaufsStatus].permittedvalues[
                                             status2item
                                          ]
                                       }
                                    </option>
                                 ),
                              )}
                        </Form.Select>
                     </Form.Group>
                     <Form.Group as={Col} controlId={"id_ordnername"} className="mb-3">
                        <Form.Label>Ordnername</Form.Label>
                        <Form.Control
                           name={config.estate.ordnerName}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={basicdata[config.estate.ordnerName] ? basicdata[config.estate.ordnerName] : ""}
                        />
                     </Form.Group>

                     <Form.Group as={Col} controlId={"id_objektbezz"} className="mb-3">
                        <Form.Label>Objektbezeichungszusatz</Form.Label>
                        <Form.Control
                           name={config.estate.objektBezeichnungszusatz}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={
                              basicdata[config.estate.objektBezeichnungszusatz]
                                 ? basicdata[config.estate.objektBezeichnungszusatz]
                                 : ""
                           }
                        />
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} controlId={"id_crmlink"} className="mb-3">
                        <Form.Label>Link zum Objekt im alten CRM</Form.Label>
                        <Form.Control
                           name={config.estate.oldCRMLink}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={basicdata[config.estate.oldCRMLink] ? basicdata[config.estate.oldCRMLink] : ""}
                        />
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} controlId={"id_benutzer"} className="mb-3">
                        <Form.Label>Objekt wurde gecheckt (Admin)</Form.Label>
                        <Form.Select
                           className={""}
                           name={config.estate.objektAbgehakt}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={basicdata[config.estate.objektAbgehakt] ?? ""}
                        >
                           <option value="">Nein</option>
                           <option value={"Ja"}>Ja</option>
                        </Form.Select>
                     </Form.Group>
                     <Form.Group as={Col} controlId={"id_crmlink"} className="mb-3">
                        <Form.Label>(Admin) Objekt in Statistiken ignorieren</Form.Label>
                        <Form.Select
                           name={config.estate.statistikAuswertungsAusnahme}
                           onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                           value={
                              basicdata[config.estate.statistikAuswertungsAusnahme]
                                 ? basicdata[config.estate.statistikAuswertungsAusnahme]
                                 : ""
                           }
                        >
                           <option value="">Nein</option>
                           <option value="Ja">Ja</option>
                        </Form.Select>
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} controlId={"id_cache"} className="mb-3">
                        <Button
                           onClick={() => {
                              localStorage.removeItem("build");
                              location.reload();
                           }}
                           className="w-25 "
                           variant="dark"
                        >
                           Cache leeren
                        </Button>
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} controlId={"id_projektstufen"} className="mb-3">
                        <Form.Label>Projektstufen deaktivieren (dunkle = Projektstufe ist deaktiviert)</Form.Label>
                        <ul className="filelist" style={{ backgroundColor: "#fafafa", borderRadius: "12px" }}>
                           {Object.keys(estatekacheln).map((stufenKey, index) => {
                              if (!isNaN(eskstatus["projekt_status_" + stufenKey]))
                                 return (
                                    <li
                                       key={"deaktiv_ps_" + index}
                                       style={
                                          eskstatus["projekt_status_" + stufenKey] >= 9
                                             ? { backgroundColor: "#0009", color: "#fff" }
                                             : {}
                                       }
                                       onClick={() => {
                                          /* let newInaktiv = structuredClone(
                                             basicdata[config.estate.inaktiveProjektstufen],
                                          );
                                          if (!newInaktiv) newInaktiv = {};
                                          if (newInaktiv[stufenKey]) {
                                             newInaktiv[stufenKey] = false;
                                          } else {
                                             newInaktiv[stufenKey] = true;
                                          }
                                          console.log(newInaktiv);

                                           changeData(config.estate.inaktiveProjektstufen, newInaktiv, "single"); */
                                          // disableProjektstufen(stufenKey, newInaktiv[stufenKey]);
                                          disableProjektstufen(stufenKey);
                                       }}
                                    >
                                       {estatekacheln[stufenKey].heading}
                                    </li>
                                 );
                           })}
                        </ul>
                     </Form.Group>
                  </Row>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={abbrechen}>
                  Schließen
               </Button>
               <Button
                  disabled={loading}
                  variant="primary"
                  onClick={async () => {
                     await sendData({});
                     setShow(false);
                  }}
               >
                  Speichern
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
